<template>
  <v-app
    style="width: 100%"
  >
    <hero-header/>
    <div
      class="indigo py-12"
    >
      <v-container
        class="indigo white--text py-12"
      >
        <message-section/>
      </v-container>
    </div>
  </v-app>
</template>

<script>
import HeroHeader from './components/HeroHeader.vue';
import MessageSection from './components/MessageSection.vue';

export default {
  name: 'App',
  components: {
    HeroHeader,
    MessageSection,
  },
};
</script>
